import React, { useContext, useState } from 'react'
import Box from '../UI/Box'
import { Button, Modal, Tabs, TabsProps } from 'antd'
import Input from '../UI/Input'
import { BuilderContext } from '../../app/builder/[id]/utils'
import { fullPath, pathToUrl } from '../../utils/router'
import routes from '../../routes'
import TextArea from '../UI/TextArea'
import IconButton from '../UI/IconButton'
import CopyToClipboardButton from '../UI/CopyToClipboardButton'
import { FiExternalLink } from 'react-icons/fi'
import { withHandledErrors } from '@utils/errors'
import { publishPreviewWidget, saveWidget } from '@api/widgets'
import { useNotification } from '@ui/NotificationProvider'
import ShareCodeContent from '@components/ShareCode/ShareCodeContent'

type Props = {
  open: boolean
  onClose: () => void
}

const ShareCode = ({ open, onClose }: Props) => {
  const notification = useNotification()
  const { widget } = useContext(BuilderContext)

  if (!open) {
    return null
  }

  return (
    <Modal
      title={<Box fontSize={22}>Add to your website</Box>}
      open
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Close
        </Button>,
      ]}
      width={850}
    >
      <ShareCodeContent />
      <br />
      <br />
      Preview your widget: <br />
      <IconButton
        type="link"
        href={fullPath(pathToUrl(routes.publicRoutes.widgetPreview, { id: widget.id }))}
        iconPostfix={FiExternalLink}
        iconSize={14}
        target="_blank"
        onClick={async () => {
          await withHandledErrors(
            notification,
            async () => {
              await saveWidget(widget)
              await publishPreviewWidget(widget.id!)
            },
            'Successfully saved',
          )
        }}
      >
        {fullPath(pathToUrl(routes.publicRoutes.widgetPreview, { id: widget.id }))}
      </IconButton>
    </Modal>
  )
}

export default ShareCode
